var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.activeComponent === 'main')?_c('IndicatorPluginMain',{on:{"setActiveComponent":_vm.setActiveComponent}}):_c('IndicatorPluginView',{on:{"setActiveComponent":_vm.setActiveComponent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }